// extracted by mini-css-extract-plugin
export default {"page":"styles_page__FHkDc","container":"styles_container__sRYK-","sub_container":"styles_sub_container__k5s8A"};